import { Injectable } from '@angular/core';
import { ValidationService } from '../base';

@Injectable({ providedIn: 'root' })
export class GoogleValidationService extends ValidationService {}
// the objectiveMarkAsTouched$ property does not exist in the GoogleValidationService class.
// Check usage of this property.
